import { render, staticRenderFns } from "./CustomersView.vue?vue&type=template&id=04a389e2&"
import script from "./CustomersView.vue?vue&type=script&lang=js&"
export * from "./CustomersView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports